import React from 'react';
import type {WidgetPart, CTAWidgetPayload} from '../types';
import CTAWidget from './cta-widget';
import {ListWidget} from './list-widget';


interface WidgetRendererProps {
  part: WidgetPart;
  onStepClick?: (
    stepId: string,
    event: {name: string; payload: Record<string, unknown>},
  ) => void;
}

export function WidgetRenderer({part, onStepClick}: WidgetRendererProps) {
  const {data} = part;

  if (data.widget_type === 'list') {
    return <ListWidget payload={data.payload} onStepClick={onStepClick} />;
  }

  if (data.widget_type === 'cta') {
    return (
      <CTAWidget
        data={data.payload as CTAWidgetPayload}
        onStepClick={onStepClick}
      />
    );
  }

  return null;
}
